import { FC } from 'react';
import { DropdownWrapperMedium } from '../../../../common/FormElementWrappers/FormElementWrappers.styles';
import Button from '../../../../components/Button/Button';
import { AddOptionPage, Buttons, Row, StyledH2 } from '../AddOption.styles';
import { SelectCharacteristicsProps } from './SelectCharacteristics.types';
import Combobox from '../../../../components/Combobox/Combobox';
import * as React from 'react';
import { AddOptionSelectable } from '../AddOption.types';
import rem from '../../../../utils/rem/rem';
import { ButtonsSeparator } from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';

const SelectCharacteristics: FC<SelectCharacteristicsProps> = ({
  formValues,
  formErrors,
  handleSelect,
  handleReviewClick,
  handleSourceClassSelect,
  classOptions,
  baseOptions,
  sizeOptions,
  productOptions,
  optionOptions,
  rawProdOptions,
  isLoading,
}) => {
  return (
    <AddOptionPage>
      <div>
        <StyledH2>Source Characteristics</StyledH2>
        <Row>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Class'}
              options={classOptions}
              value={formValues.sourceClass ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSourceClassSelect(newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceClass}
              testId='sourceClassCombobox'

            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Base'}
              options={baseOptions}
              value={formValues.sourceBase ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('sourceBase', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceBase}
              testId='sourceBaseCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Size'}
              options={sizeOptions}
              value={formValues.sourceSize ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('sourceSize', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceSize}
              testId='sourceSizeCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Prod'}
              options={productOptions}
              value={formValues.sourceProd ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('sourceProd', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceProd}
              testId='sourceProdCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Option'}
              options={optionOptions}
              value={formValues.sourceOption ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('sourceOption', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceOption}
              testId='sourceOptionCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Source Raw Product'}
              options={rawProdOptions}
              value={formValues.sourceRawProd ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('sourceRawProd', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.sourceRawProd}
              testId='sourceRawProdCombobox'
            />
          </DropdownWrapperMedium>
        </Row>
      </div>
      <ButtonsSeparator style={{marginBottom: rem(43), marginTop: rem(43), paddingBottom: 'unset' }} />
      <div>
        <StyledH2>Target Characteristics</StyledH2>
        <Row>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Class'}
              options={classOptions}
              value={formValues.targetClass ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetClass', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetClass}
              testId='targetClassCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Base'}
              options={baseOptions}
              value={formValues.targetBase ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetBase', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetBase}
              testId='targetBaseCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Size'}
              options={sizeOptions}
              value={formValues.targetSize ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetSize', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetSize}
              testId='targetSizeCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Prod'}
              options={productOptions}
              value={formValues.targetProd ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetProd', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetProd}
              testId='targetProdCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Option'}
              options={optionOptions}
              value={formValues.targetOption ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetOption', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetOption}
              testId='targetOptionCombobox'
            />
          </DropdownWrapperMedium>
          <DropdownWrapperMedium>
            <Combobox
              label={'Target Raw Product'}
              options={rawProdOptions}
              value={formValues.targetRawProd ?? null}
              setSelectedOption={(_event: React.SyntheticEvent, newValue: AddOptionSelectable | null) => {
                handleSelect('targetRawProd', newValue);
              }}
              isOptionEqualToValue={(option, value) => option.value === value?.value ?? null}
              width={rem(190)}
              errorText={formErrors.targetRawProd}
              testId='targetRawProdCombobox'
            />
          </DropdownWrapperMedium>
        </Row>
      </div>
      <Buttons>
        <div></div>
        <Button
          label='Review'
          onClick={handleReviewClick}
          isLoading={isLoading}
          loadingLabel='Loading'
          testId={'reviewButton'}
        />
      </Buttons>
    </AddOptionPage>
  );
};

export default SelectCharacteristics;
